/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Offline_Failed_BodyInputs */



/**
* | output |
* | --- |
* | "The recording could not be transcribed. Record the conversation again, or share your own notes." |
*
* @param {Meeting_Offline_Failed_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_offline_failed_body = /** @type {((inputs?: Meeting_Offline_Failed_BodyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Offline_Failed_BodyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("De opname kon niet uitgeluisterd worden. Neem het gesprek opnieuw op, of deel je eigen notities.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("L'enregistrement n'a pas pu être transcrit. Enregistrez la conversation à nouveau, ou partagez vos propres notes.")
	return /** @type {LocalizedString} */ ("The recording could not be transcribed. Record the conversation again, or share your own notes.")
});